<template>
    <div class="card-review">
        <div class="stars-rating">
            <div
                v-for="index in 5"
                :key="index"
                :class="getClassStar(index)"
                class="star"
            ></div>
        </div>

        <div class="review">
            {{ review }}
        </div>

        <div
            v-if="author"
            class="author"
        >
            {{ author }}
        </div>

        <div class="date">
            {{ date }}
        </div>
    </div>
</template>

<script lang="ts">
import type { ArrayElement } from '@/types/utils'
import type { ComponentReviewCarouselFragment } from '@/graphql/api'

export type Review = Omit<
    ArrayElement<ComponentReviewCarouselFragment['reviews']>,
    '__typename'
>
</script>

<script lang="ts" setup>
const props = defineProps<{
    date: string
    review: string
    author?: string | null
    starsCount: number
}>()

// TODO have different icons in the font for each grade
// this will eliminate the extra divs and the reduce render time
const getClassStar = (index: number) =>
    props.starsCount >= index ? 'filled' : 'outlined'
</script>

<style lang="scss" scoped>
.card-review {
    position: relative;
    // width: 100%;
    height: 396px;
    border: 1px solid $grey-300;
    z-index: 2;
    padding: 120px 16px 0;

    // @include min-width(1024) {
    //     width: 344px;
    // }

    .stars-rating {
        margin-bottom: 24px;
        display: flex;
        justify-content: center;

        .star {
            position: relative;
            margin: 0 3px;
            width: 19px;
            height: 18px;

            &::before {
                position: absolute;
                content: '';
                width: 19px;
                height: 18px;
                background: url('@/assets/icons/star-outlined-slate.svg');
            }

            &.filled::before {
                background: url('@/assets/icons/star-filled-slate.svg');
            }
        }
    }

    .review,
    .author,
    .date {
        font-family: $sectra-font-stack;
        font-style: normal;
        font-weight: 400;
        font-size: 1.25rem;
        line-height: 1.5rem;
        text-align: center;
        font-feature-settings:
            'pnum' on,
            'lnum' on;
    }

    .review {
        margin-bottom: 24px;
    }

    .author {
        margin-bottom: 8px;
    }

    .date {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }
}
</style>
